import { useState, useEffect } from 'react'
import { getRecentStudies, getStudiesByStatus } from '../../../api/studyListApi'
import TileHeader from '../../../components/TileHeader/TileHeader'
import { Container, ContentContainer } from '../../../components/Wrapper/Wrapper'
import StudyPieChart from './Dashboards/StudyPieChart'
import RecentStudies from './Dashboards/RecentStudies'
import styled from 'styled-components';
const AnalyticsDashboard = () => {
  const [studyByStatus, setStudyByStatus] = useState({})
  const [recentStudies, setRecentStudies] = useState([])

  useEffect(() => {
    getStudiesByStatus().then(res => {console.log('res', res); setStudyByStatus(res)})
    // setStudyByStatus()
    getRecentStudies().then(res => setRecentStudies(res.results))
  }, [])

  return(
    <Container>
      <ContentContainer>
      <TileHeader
        title="Metrics"
        subtitle=""
        size="lg"
      />
      <RecentStudies data={recentStudies} />
      <StudyPieChart data={studyByStatus} />
      </ContentContainer>
     </Container>
  )
}

export default AnalyticsDashboard

// const AgGridContainer = styled.div`
//   display: flex;
// `

// const WidgetContainer = styled.div`
//   width: 50%;
//   heigh: 100%;
// `

